/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/tag_medium'
export default icon
